import { calculateBillableBudget } from '../utils/billable-field-helpers';
import getEventTargetValue from '../utils/get-event-target-value';
import { changeQuote } from './actions';
import { connectEditor } from './connect-editor';
import QuoteForm from './QuoteForm';
import { calculateInvoiceSums } from './utils/calculate-derived-values';

export default connectEditor(
  state => ({
    model: state.quote,
    isCommercialIncentiveModalVisible:
      state.quoteUI.isCommercialIncentiveModalVisible,
    invoiceSums: calculateInvoiceSums({
      quote: state.quote, // for the invoice amount
      quoteLinesById: state.quoteLinesById, // for the discounts & co-invest expenditures
    }),
    billableBudgets: calculateBillableBudget({
      opportunity: state.opportunity,
      productsById: state.productsById,
      quote: state.quote,
      quoteLinesById: state.quoteLinesById,
    }),
  }),
  {
    onChange: event =>
      changeQuote(event.target.name, getEventTargetValue(event.target)),
  },
)(QuoteForm);
